import React from "react";
import Slider from "react-slick";
import "./FreeTrialSection.css";
import trialImage from "../Assets/coursefreetrial.png"; // Update path
import patternBg from "../Assets/Triangle.png"; // Update path

const CoursetFreeTrial = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <div className="free-trial-section">
      {/* Desktop Layout */}
      <div className="free-trial-desktop">
        <div className="text-content blue-bg1">
          <h2>Join Our Program and Level Up Your English</h2>
          <p>
           Whether you need to improve grades, get ready to study abroad, or simply communicate better, we have something for you. Use the best online English courses, skilled tutors, and flexible study options to see faster improvement than you thought possible. Our online English courses with certificates not only boost your language skills but also give you credentials that stand out on applications and resumes.
          </p>
          <p>
          With expert English speaking tutors, interactive lessons, and real-life practice, you will gain confidence to speak, write, and understand English in any setting. From academic success to career growth, we’re here to guide you at every step.
          </p>
          <p>
Why hold back? Begin your journey now and make your first move to speak English fluently and confidently. NewZeal Language Academy – A place where students master English not just to succeed in exams, but to unlock global opportunities and build a future without language </p>
        </div>
        <div className="image-content">
          <img src={trialImage} alt="Free Trial" className="main-img1" />
          <img src={patternBg} alt="" className="pattern-bg" />
        </div>
      </div>

      {/* Mobile Slider */}
      <div className="free-trial-mobile">
        <Slider {...sliderSettings}>
          <div>
            <div className="text-content blue-bg">
              <h2>Free Trial & Affordable Learning</h2>
              <p>
                We understand that choosing an English course is a commitment.
                That's why we offer a free trial class so you can experience our
                teaching style before enrolling. Our plans are affordable and
                flexible, making it easier for you to start learning without
                financial stress.
              </p>
              <p>
                If you're just starting and want to learn English online for
                free, our blog and resource library also provide useful tips,
                exercises, and self-learning materials.
              </p>
            </div>
          </div>
          <div>
            <div className="image-content">
              <img src={trialImage} alt="Free Trial" className="main-img" />
              <img src={patternBg} alt="" className="pattern-bg" />
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default CoursetFreeTrial;
